import styled, { css } from "styled-components";

export const ButtonStyled = styled.div`
  padding: 5px;
  background-color: ${({theme}) => theme.colors.surface.surfaceOutline};
  border-radius: 5px;
  margin-left: 6px;
  border: none;
  cursor: pointer;

  &:hover {
    background-color: ${({theme}) => theme.colors.surface.onSurfacePlaceholder};
  }

  .preferencesOpenBtn {
    color: ${({theme}) => theme.colors.secondary.onSecondary} !important;
  }
`;

export const Overlay = styled.div`
  width: 300px;
  max-width: 300px;
`;

export const SearchContent = styled.div`
  display: flex;
  margin-top: 12px;
  max-height: 205px;
  padding: 6px;
  padding-bottom: 0;

  .searchWrapper {
    display: flex;
    align-items: center;
    width: 100%;
    height: 32px;
    overflow: hidden;
    border-radius: 6px;
    background-color: ${({theme}) => theme.colors.secondary.secondary};
    
    .searchInput {
      width: 100%;
      background-color: ${({theme}) => theme.colors.secondary.secondary};
    }
  }
`;

export const MainContent = styled.div`
  max-height: 268px;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 6px;
`;

export const Main = styled.div`
  display: flex;
  flex-direction: column;

  .mainTitle {
    font-size: 10px;
    font-weight: 400;
    line-height: 16px;
    color: ${({theme}) => theme.colors.surface.onSurfaceVariant};
    margin-left: 6px;
  }

  .mainFollowers {
    display: flex;
    flex-direction: column;
  }
`;

export const HrContainer = styled.div`
  width: 100%;
  padding: 0 8px;
  margin: 8px 0;
  
  hr {
    border: 1px solid ${({ theme }) => theme.colors.surface.surfaceOutline};
  }
`;

interface IFooterContent {
  youfollower?: boolean;
}

export const FooterContent = styled.div<IFooterContent>`
  width: 100%;
  height: 44px;
  padding: 0 6px;
  display: flex;
  align-items: center;
  
  .btnFollow {
    width: 100%;
    height: 32px !important;
    display: flex;
    align-items: center;
    justify-content: center;

    .btnFollowIcon {
      color: ${({ theme }) => theme.colors.primary.onPrimary} !important;
    }
  
    .btnFollowText {
      font-size: 12px;
      font-weight: 600;
      line-height: 16px;
      color: ${({theme}) => theme.colors.primary.onPrimary};
      margin-left: 6px;
    }
  }

  ${({youfollower, theme}) => youfollower && css`

    .btnFollow {

      .btnFollowIcon {
        color: ${theme.colors.surface.onSurfaceVariant} !important;
      }
    
      .btnFollowText {
        color: ${theme.colors.surface.onSurface};
      }
    }
  `}
`;
